/* eslint-disable import/prefer-default-export */
/**
 * 파일 관련 유틸
 */
import { isNil, forEach } from 'lodash';
import store from '@/store';

/**
 * 파일 용량이 최대 사이즈를 넘지 않는지 체크한다.
 * @author Ju
 * @param  {Number} size 파일 사이즈
 * @return {Object}      결과 객체 ( { enable: {Boolean}, message: {String} } ) - enable: 업로드 가능 여부 (true:가능/false:불가), message: 파일 관련 체크 메시지
 */
export function checkFileSize(size) {
  const maxFileMBSize = store.state.common.fileMaxMbSize;
  if (size > maxFileMBSize * 1024 * 1024) {
    return {
      enable: false,
      message: `파일이 최대 파일 크기(${maxFileMBSize}MB)를 초과하여 업로드할 수 없습니다.`,
    };
  }
  return {
    enable: true,
  };
}

/**
 * 피일명에서 파일 확장자를 구한다.
 * @author Ju
 * @param  {String} fileName 파일명(확장자포함)
 * @return {String}          파일 확장자
 */
export function getFileExtensionFromName(fileName) {
  if (!isNil(fileName) && fileName !== '') {
    const index = fileName.lastIndexOf('.');
    if (index > 0) {
      return fileName.toLowerCase().substring(index + 1); // '.'을 제외한 소문자 확장자만 리턴한다.
    }
  }
  return null;
}

/**
 * 파일명에서 확장자를 제외한 파일명을 반환한다.
 * @author Ju
 * @param  {String} fileName 파일명(확장자포함)
 * @return {String}          파일명
 */
export function getFileNameExceptExtension(fileName) {
  if (!isNil(fileName) && fileName !== '') {
    const index = fileName.lastIndexOf('.');
    if (index > 0) {
      return fileName.substring(0, index);
    }
  }
  return null;
}

/**
 * 파라미타로 전달된 url로 요청을 보내 파일을 다운로드한다.
 * method는 GET방식
 * @author Ju
 * @param  {String} url    요청 url
 * @param  {Object} params 요청 파라미터
 * @param  {String} method 요청 방식. 기본 값은 GET
 * @return {[type]}        [description]
 */
export function downloadFile(url, params, method = 'GET') {
  const form = document.createElement('form');
  form.action = url;
  form.method = method;
  forEach(params, (value, key) => {
    const hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', value);
    form.appendChild(hiddenField);
  });
  document.body.appendChild(form);
  form.submit();

  document.body.removeChild(form);
}

/**
 * 비인가 확장자 파일인지 확인한다.
 * 비인가 확장자 파일인 경우(return true) 업로드 불가능
 * @author NaJY
 * @param  {Object}  file   파일 객체
 * @return {Boolean}        비인가 확장자 파일 여부
 */
export function isUnauthorizedFile(file) {
  const unauthorizedFileType = ['jsp', 'cgi', 'php', 'asp', 'aspx', 'exe', 'com', 'html', 'htm', 'cab', 'php3', 'pl', 'java', 'class', 'js', 'css', 'bat', 'sh'];
  const fileType = getFileExtensionFromName(file.name);
  const authorizedFileFlag = unauthorizedFileType.findIndex((type) => type === fileType) > -1;

  return authorizedFileFlag;
}

/**
 * 이미지 확장자 파일인지 확인한다.
 * 이미지 확장자 파일인 경우(return true)에만 업로드
 * @author NaJY
 * @param  {Object}  file   파일 객체
 * @return {Boolean}        이미지 확장자 파일 여부
 */
export function isImageFile(file) {
  const imageFileType = ['jpg', 'jpeg', 'png', 'gif'];
  const fileType = getFileExtensionFromName(file.name);
  const imageFileFlag = imageFileType.findIndex((type) => type === fileType) > -1;

  return imageFileFlag;
}



// WEBPACK FOOTER //
// ./src/utils/file.js